<template>
  <div class="row" v-if="active==true">
    <div class="col-md-12">
      <div class="card">
        <div class="container">
          <div class="row">
            <div class="offset-md-3 offset-xs-3 offset-sm-3 col-md-6 col-xs-6 col-sm-6">
              <div v-if="percent<100">
                <center><img src="/img/loadding.svg"></center>
                <h4 class="text-center ld ld-jump x4"><b>Loadding</b><span v-if="percent>0"> {{percent}} %</span><span v-if="percent==0">...
                  </span></h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    StockAdd
  } from '@/router'

  export default {
    props: {
      percent: 0,
      active: false
    }
  };

</script>
